"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cellara": {
    "918dab18": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "cancello": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a7eeb6f6": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "casignano": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9b9ec13": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "cognale-del-piro": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f2b6586": [{
      "hkey": "6431cceb",
      "slug": "contrada-riposo",
      "name": "Contrada Riposo",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-riposo": [{
      "hkey": "6431cceb",
      "slug": "contrada-riposo",
      "name": "Contrada Riposo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "238f29c5": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "cugnalicchi": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b37ed80": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "destre": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12c31da3": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "diroito": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "17ad02cc": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "foresti": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "00076263": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "gesuri": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b31c1e9e": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "giardino": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3a031c0": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "pantano": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e5d1f63e": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "piantoni": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9a682b5": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "piticchia": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12edd2a1": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "quaranta": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "68eb021c": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "san-domenico": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "922e5ea5": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "san-vito": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f221aa2": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "skipSearch": false
    }],
    "torre-salato": [{
      "hkey": "f43a957f",
      "slug": "cellara",
      "name": "Cellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;